var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.operatorDialogOpen,
        width: "500px",
        "append-to-body": "",
        "destroy-on-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.operatorDialogOpen = $event
        },
        close: _vm.resetForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.closeOrderFormRule },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  placeholder: _vm.closeOrderFormRule.content[0].message,
                },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "text" },
              on: {
                click: function ($event) {
                  _vm.operatorDialogOpen = false
                },
              },
            },
            [_vm._v(" 取消 ")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "re-click", rawName: "v-re-click" }],
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.handleCloseOrderConfirm },
            },
            [_vm._v(" 确认 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }